import * as actionTypes from '../constant/event'
import {apiCall} from '../../service/apiCall'
import {setLoading,setLoading2} from './general'
import {get} from 'lodash'
import { URL, USER,PASS } from '../../service/base_url'
export const catalougeDownload=(slug='')=>async dispatch=>{
    dispatch(setLoading2(true))
    let dataReq={
        url:`/web/ecatalog${slug}`,
        method:'POST',
        data:{
            auth:{username:USER,password:PASS}
        }
    }
    let res=await dispatch(apiCall(dataReq))
    if(get(res,'status')==200){
        dispatch(setLoading2(false))
        
        return res
    }else{
        dispatch(setLoading2(false))

       
    }
}